import React from 'react';
import { GatsbyImage } from "gatsby-plugin-image";
import {Clients, Services, Wait, Community, Motivate, National, Paper, Risks, Goals, Inform, Standardize, Mobilize, Thumbs, Editing, Experience, Profitable, RightTime, Sales, Timesaver, Guide, Region, Welcome} from '../../../../../components/svgs/advantages';
import {colors} from '../../../../../style/constants';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    height: 'auto',
    border: '10px black solid',
    borderRadius: 10,
    boxSizing: 'border-box',
    boxShadow: '-20px 20px 20px 0px rgba(0,0,0,0.5)',
    marginBottom: 60,
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      border: '5px black solid',
      borderRadius: 5,
      boxShadow: '-10px 10px 10px 0px rgba(0,0,0,0.5)',
    },
  },
  icon: {
    boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.25)',
    background: colors.TURQUOISE,
    width: 90,
    height: 90,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: -45,
    left: -45,
    zIndex: 1,
    [theme.breakpoints.down('md')]: {
      height: 80,
      width: 80,
      top: -40,
      left: -40,
      [theme.breakpoints.down('xs')]: {
        height: 60,
        width: 60,
        top: -30,
        left: -30,
      },
    },
    '& svg': {
      width: '100%',
      height: '100%',
      padding: 20,
      boxSizing: 'border-box',
      filter: 'brightness(0) invert(1)',
      [theme.breakpoints.down('sm')]: {
        padding: 15,
        [theme.breakpoints.down('xs')]: {
          padding: 12,
        },
      },
    }
  }
}));


const Display = (props) => {

  const renderIcon = () => {
    if(props.item.icon === 'clients'){
      return <Clients />
    }
    if(props.item.icon === 'services'){
        return <Services />
    }
    if(props.item.icon === 'wait'){
      return <Wait />
    }
    if(props.item.icon === 'community'){
        return <Community />
    }
    if(props.item.icon === 'motivate'){
      return <Motivate />
    }
    if(props.item.icon === 'national'){
        return <National />
    }
    if(props.item.icon === 'paper'){
      return <Paper />
    }
    if(props.item.icon === 'risks'){
      return <Risks />
    }
    if(props.item.icon === 'goals'){
      return <Goals />
    }
    if(props.item.icon === 'inform'){
        return <Inform />
    }
    if(props.item.icon === 'standardize'){
      return <Standardize />
    }
    if(props.item.icon === 'mobilize'){
      return <Mobilize />
    }
    if(props.item.icon === 'thumbs'){
      return <Thumbs />
    }
    if(props.item.icon === 'editing'){
      return <Editing />
    }
    if(props.item.icon === 'experience'){
      return <Experience />
    }
    if(props.item.icon === 'profitable'){
        return <Profitable />
    }
    if(props.item.icon === 'right-time'){
      return <RightTime />
    }
    if(props.item.icon === 'sales'){
      return <Sales />
    }
    if(props.item.icon === 'timesaver'){
      return <Timesaver />
    }
    if(props.item.icon === 'guide'){
      return <Guide />
    }
    if(props.item.icon === 'region'){
      return <Region />
    }
    if(props.item.icon === 'welcome'){
      return <Welcome />
    }
  }

  const classes = useStyles();
  return (
    <Container>
      <Grid container justifyContent='center'>
        <Grid item xs={10} sm={8} lg={6} className={classes.wrapper} active={props.index}>
          <div className={classes.icon}>{renderIcon()}</div>
          <GatsbyImage image={props.item.visual.gatsbyImageData} alt={props.item.title} />
        </Grid>
      </Grid>
    </Container>
  )

}

export default Display;